import Currency from '@/utils/currency';

const configurator = {
	methods: {
		getPrice(price, modality) {
			const priceString = Currency.floatToEuro(price);
			switch (modality) {
			case 'Flat':
				return `${priceString} ${this.$t('configurator.flatRate')}`;
			case 'PerPerson':
				return `${priceString} ${this.$t('configurator.perPerson')}`;
			default:
				return priceString;
			}
		},

		/**
     * Returns true if a input e.g. 'tel' type should be handled like normal input
     * Usefull for choosing the correct component when iterating through form configuration files.
     * @param {String} inputType - the input type of the component to be checked
     */
		isInput(inputType) {
			const allowedInputTypes = [
				'text',
				'tel',
				'email',
				'date',
				'time',
			];
			return allowedInputTypes.includes(inputType);
		},
	},
};

export { configurator as default };
